<template>
	<div class="ai-chat">
		<div ref="scroll" class="ai-chat-body" data-tour="conversation">
			<div v-if="prompt" class="ai-system">
				<button type="button" class="ai-system-toggle" @click="mostraPrompt = !mostraPrompt">
					<v-icon x-small class="mr-1">mdi-cog-outline</v-icon>Prompt di sistema
					<v-icon x-small class="ml-1">{{ mostraPrompt ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
				</button>
				<div v-if="mostraPrompt" class="ai-system-text">{{ prompt }}</div>
			</div>

			<div v-for="(msg, i) in messaggi" :key="msg.id || i" class="ai-row" :class="msg.role === 'user' ? 'ai-row--user' : 'ai-row--bot'">
				<div class="ai-avatar" :class="msg.role === 'user' ? 'ai-avatar--user' : 'ai-avatar--bot'">
					<v-icon small :color="msg.role === 'user' ? 'white' : 'primary'">{{ msg.role === 'user' ? 'mdi-account' : 'mdi-robot-outline' }}</v-icon>
				</div>
				<div class="ai-bubble" :class="[msg.role === 'user' ? 'ai-bubble--user' : 'ai-bubble--bot', { 'ai-bubble--wide': msg.products && msg.products.length }]">
					<div class="ai-text">{{ msg.content }}</div>
					<div v-if="msg.products && msg.products.length" class="ai-products" data-tour="products">
						<div v-for="prod in msg.products" :key="prod._id" class="ai-product">
							<img v-if="immagine(prod)" :src="immagine(prod)" alt="" />
							<div v-else class="ai-product-noimg"><v-icon small>mdi-image-off-outline</v-icon></div>
							<div class="ai-product-body">
								<div class="ai-product-name" :title="nome(prod)">{{ nome(prod) }}</div>
								<div class="ai-product-brand">
									<span v-if="prezzo(prod)" class="ai-product-price">{{ prezzo(prod) }}</span>
									<span v-if="prezzo(prod) && brand(prod)"> · </span>{{ brand(prod) }}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div v-if="!messaggi.length" class="ai-empty">Nessun messaggio</div>
		</div>
	</div>
</template>

<script>
// conversazione con l'assistente AI del sito pubblico, in sola lettura
export default {
	name: 'AssistantChat',
	props: {
		messages: { type: Array, default: () => [] },
	},
	data() {
		return { mostraPrompt: false };
	},
	computed: {
		// il messaggio "system" e' il prompt dell'assistente: non e' una battuta della chat
		prompt() {
			const system = this.messages.find(m => m.role === 'system');
			return system ? system.content : '';
		},
		messaggi() {
			return this.messages.filter(m => m.role !== 'system');
		},
	},
	mounted() {
		this.$nextTick(this.scrollInFondo);
		// le miniature dei prodotti cambiano altezza dopo il caricamento
		this.$refs.scroll.addEventListener('load', this.scrollInFondo, true);
		setTimeout(() => this.$refs.scroll && this.$refs.scroll.removeEventListener('load', this.scrollInFondo, true), 3000);
	},
	beforeDestroy() {
		this.$refs.scroll.removeEventListener('load', this.scrollInFondo, true);
	},
	methods: {
		scrollInFondo() {
			const el = this.$refs.scroll;
			if (el) el.scrollTop = el.scrollHeight;
		},
		// due formati salvati: vecchio (trans/images/brand) e attuale della card storefront (name/imageSrc/price)
		immagine(prod) {
			if (prod.imageSrc) return prod.imageSrc;
			return prod.images && prod.images[0] && prod.images[0].sizes && prod.images[0].sizes[0] ? prod.images[0].sizes[0].value : '';
		},
		nome(prod) {
			return prod.name || (prod.trans && prod.trans.name) || '';
		},
		brand(prod) {
			return (prod.brand && prod.brand.trans && prod.brand.trans.name) || '';
		},
		prezzo(prod) {
			const n = parseFloat(prod.price);
			return isNaN(n) ? '' : n.toFixed(2).replace('.', ',') + ' €';
		},
	},
};
</script>

<style scoped>
.ai-chat {
	border: 1px solid rgba(0, 0, 0, 0.12);
	border-radius: 10px;
	overflow: hidden;
	background: #f3f6fa;
	max-width: 820px;
	margin: 0 auto;
}
.ai-chat-body {
	max-height: 480px;
	overflow-y: auto;
	padding: 10px 12px;
	-webkit-overflow-scrolling: touch;
}
.ai-system {
	text-align: center;
	margin: 2px 0 10px;
}
.ai-system-toggle {
	display: inline-flex;
	align-items: center;
	font-size: 12px;
	color: #5f6b7a;
	background: #e4eaf2;
	border-radius: 12px;
	padding: 3px 10px;
}
.ai-system-text {
	text-align: left;
	margin-top: 8px;
	font-size: 12px;
	line-height: 1.45;
	color: #5f6b7a;
	background: #fff;
	border: 1px dashed #c9d3df;
	border-radius: 8px;
	padding: 8px 10px;
	white-space: pre-line;
	word-break: break-word;
	max-height: 220px;
	overflow-y: auto;
}
.ai-row {
	display: flex;
	align-items: flex-end;
	gap: 6px;
	margin-bottom: 8px;
}
.ai-row--user {
	flex-direction: row-reverse;
}
.ai-avatar {
	flex: 0 0 28px;
	width: 28px;
	height: 28px;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
}
.ai-avatar--user {
	background: #01579b;
}
.ai-avatar--bot {
	background: #fff;
	border: 1px solid #d5dee9;
}
.ai-bubble {
	position: relative;
	max-width: 70%;
	padding: 7px 11px;
	border-radius: 12px;
	font-size: 14px;
	line-height: 1.45;
	word-break: break-word;
	box-shadow: 0 1px 1px rgba(16, 38, 66, 0.08);
}
.ai-bubble--user {
	background: #01579b;
	color: #fff;
	border-bottom-right-radius: 3px;
}
.ai-bubble--bot {
	background: #fff;
	color: #1f2d3d;
	border: 1px solid #e1e7ef;
	border-bottom-left-radius: 3px;
}
.ai-text {
	white-space: pre-line;
}
.ai-products {
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
	gap: 6px;
	margin-top: 8px;
}
.ai-product {
	display: flex;
	align-items: center;
	gap: 8px;
	background: #f7f9fc;
	border: 1px solid #e1e7ef;
	border-radius: 8px;
	padding: 6px;
	min-width: 0;
}
.ai-product img,
.ai-product-noimg {
	flex: 0 0 48px;
	width: 48px;
	height: 48px;
	object-fit: contain;
	border-radius: 4px;
	background: #fff;
}
.ai-product-noimg {
	display: flex;
	align-items: center;
	justify-content: center;
}
.ai-product-body {
	min-width: 0;
}
.ai-product-name {
	font-size: 13px;
	font-weight: 500;
	line-height: 1.3;
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	overflow: hidden;
}
.ai-product-brand {
	font-size: 12px;
	color: #5f6b7a;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
.ai-product-price {
	color: #01579b;
	font-weight: 600;
}
.ai-empty {
	text-align: center;
	color: #5f6b7a;
	font-size: 13px;
	padding: 24px 0;
}

@media (max-width: 768px) {
	.ai-chat {
		margin: 0 -4px;
	}
	.ai-chat-body {
		max-height: 60vh;
		padding: 8px;
	}
	.ai-bubble {
		max-width: 82%;
	}
	/* con i prodotti il fumetto usa tutta la larghezza disponibile */
	.ai-bubble--wide {
		max-width: calc(100% - 34px);
		flex: 1 1 auto;
	}
	.ai-products {
		grid-template-columns: 1fr;
	}
}
</style>
